import * as brandColors from '../../../utils/brand-colors';

export default (theme) => ({
  root: theme.mixins.gutters({
    padding: 16,
    marginTop: theme.spacing(3),
  }),
  container: {
    paddingBottom: '2rem',
    width: '100vw',
    minHeight: '100vh',
  },
  content: {
    margin: 'auto',
    padding: '6rem 0 0',
    width: 500,
    maxWidth: '90vw',
  },
  buttonContainer: {
    margin: '2rem auto 1rem',
    display: 'block',
    width: 'fit-content',
  },
  icon: {
    fontSize: '6rem',
    color: brandColors.danger.main,
    margin: 'auto',
    display: 'block',
  },
});
